import { AttributionRow } from '../components/AttributionRow';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './ResearchHeroSection.module.css';

const attributionItems = [
  {
    label: 'Study',
    value: 'AIMS - Artificial Intelligence and Math Skills',
  },
  {
    label: 'Lead author',
    value: 'Yifan Lu (UCLA Physics & Astronomy)',
  },
  {
    label: 'Published',
    value: 'Phys. Rev. PER, June 2025',
  },
  {
    label: 'Funder',
    value: 'UCLA Teaching & Learning Center',
  },
];

export function ResearchHeroSection() {
  return (
    <SectionWrapper
      background="white"
      className={styles.heroSection}
      data-testid="research-section-hero"
    >
      <div className={styles.hero}>
        <div className={styles.eyebrowRow}>
          <span className={styles.badge}>PEER-REVIEWED</span>
          <span className={styles.publication}>
            Physical Review Physics Education Research, June 2025
          </span>
        </div>
        <h1 className={styles.title}>
          AI-generated hints in Kudu are associated with improved exam
          performance - especially for students who need help most.
        </h1>
        <p className={styles.body}>
          A peer-reviewed study from researchers at UCLA and UC San Diego
          examined two interventions deployed in Kudu: scaled extra credit on
          supplemental math, and AI-generated hints embedded in physics
          homework. Both interventions correlated with higher exam scores and
          reduced disparities in completion rates among students from groups
          historically underserved in introductory STEM.
        </p>
        <AttributionRow items={attributionItems} />
      </div>
    </SectionWrapper>
  );
}
